var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as StaticImageFactory from "../../classes/definitions/staticImage/staticImage";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import StaticImagesList from '../../components/StaticImages/StaticImagesList/StaticImagesList';
import AppRoutes from '../../config/appRoutes';
import StaticImagesReduxProps from "./StaticImagesReduxProps";
var StaticImages = /** @class */ (function (_super) {
    __extends(StaticImages, _super);
    function StaticImages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { pageNumber: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null,
            delaySearchTimer: null
        };
        _this.getAllStaticImages = function (params) {
            _this.api.getStaticImages(params)
                .then(function (response) {
                var staticImages = StaticImageFactory.createStaticImages(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: staticImages, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка със статични картинки', _this.props.history);
            });
        };
        _this.toNewStaticImage = function () {
            _this.props.history.push(AppRoutes.staticImage.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        _this.search = function (event) {
            _this.queryParams.filter = event.target.value;
            clearTimeout(_this.state.delaySearchTimer);
            _this.setState({
                delaySearchTimer: setTimeout(function () {
                    _this.getAllStaticImages(_this.queryParams);
                }, 1000)
            });
        };
        return _this;
    }
    StaticImages.prototype.componentDidMount = function () {
        this.getAllStaticImages(this.queryParams);
    };
    StaticImages.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0421\u0442\u0430\u0442\u0438\u0447\u043D\u0438 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewStaticImage, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u0441\u0442\u0430\u0442\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(StaticImagesList, { gridData: data, meta: meta, getAllStaticImages: this.getAllStaticImages, messages: this.messages, deleteItem: this.deleteItem, search: this.search }))))));
    };
    return StaticImages;
}(React.Component));
export default connect(null, StaticImagesReduxProps.mapDispatchToProps)(StaticImages);



//////////////////
// WEBPACK FOOTER
// ./src/views/StaticImages/StaticImages.tsx
// module id = 476
// module chunks = 0